module.exports = __webpack_public_path__ + "img/drag-icon.120fb9fe.svg";